import api from "@/assets/js/api.js";
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於彈出提示

export default {
  name: "OrderManagement",
  data() {
    return {
      orders: [], // 從後端取得的訂單資料
      searchQuery: "", // 搜尋輸入框的內容
      showModal: false, // 控制模態窗顯示
      currentOrder: null, // 當前選中的訂單
    };
  },
  computed: {
    // 根據搜尋關鍵字過濾訂單
    filteredOrders() {
      if (!this.searchQuery) {
        return this.orders;
      }
      return this.orders.filter((order) =>
        order.userName.includes(this.searchQuery)
      );
    },
  },
  methods: {
    // 從後端取得訂單資料
    async fetchOrders() {
      try {
        const response = await api.get("Order/GetAllOrders");
        this.orders = response.data
          .map((user) => {
            return user.orders.map((order) => ({
              userName: user.fullName,
              ...order,
            }));
          })
          .flat(); // 將多層陣列展平成單層
      } catch (error) {
        console.error("取得訂單資料失敗：", error);
      }
    },
    // 格式化日期為 YYYY-MM-DD
    formatDate(date) {
      if (!date) return "無資料";
      return new Date(date).toISOString().split("T")[0];
    },
    // 打開模態窗
    openModal(order) {
      this.currentOrder = { ...order }; // 深拷貝，避免直接修改原數據
      this.showModal = true;
    },
    // 關閉模態窗
    closeModal() {
      this.showModal = false;
      this.currentOrder = null;
    },
    // 更新訂單
    async updateOrder() {
      try {
        // 構造 query string
        const params = new URLSearchParams({
          orderId: this.currentOrder.orderId,
          paymentStatus: this.currentOrder.paymentStatus,
          orderStatus: this.currentOrder.orderStatus,
        });

        // 發送 GET 請求或 PUT 請求帶有 query string
        await api.put(`/Order/UpdateOrderStatus?${params.toString()}`);
        Swal.fire({
          icon: "success", // ✅ 成功圖示
          title: "更新成功", // 標題
          text: "訂單更新成功！", // 內容
          confirmButtonText: "確定", // 按鈕
        });
        
        this.closeModal();
        this.fetchOrders(); // 重新取得訂單資料
      } catch (error) {
        console.error("更新訂單失敗：", error);
        Swal.fire({
          icon: "error", // ❌ 錯誤圖示
          title: "更新失敗", // 標題
          text: "更新失敗，請稍後再試！", // 內容
          confirmButtonText: "確定", // 按鈕
        });
        
      }
    },
  },
  mounted() {
    this.fetchOrders(); // 頁面載入時取得訂單資料
  },
};
